/**
 * Store utilisateurs
 */
import { defineStore } from "pinia";

import { useCenterStore } from "./center.store";
import { useOptions } from "./options.store";
import { FrontUser } from "../models/user";
import { CenterAuthorize, ICenter } from "../models/center";
import AuthenticationHelper from "../helper/OIDCManager";
import { CenterUserList } from "../helper/type";
import CenterService from "../services/CenterServices";

import { IOptionFilter } from "../models/filters/optionFilter";
import CbCenterItem from "../components/Header/CbCenterItem";
import { IParameter } from "../models/parameter";
import { ICenterFilter } from "../models/filters/centerFilter";

const authenticationHelper = new AuthenticationHelper();

export const useUsersStore = defineStore("users", {
    state: () => ({
        currentUser: {} as FrontUser,
        currentCenter: {} as ICenter,
    }),
    getters: {
        isConnect : (state):boolean => {
            return state.currentUser != undefined;
        },
        getCurrentSociety: (state): IParameter|undefined => {
            return state.currentCenter?.society;
        },
        getCentersUserCbItem: (state):CbCenterItem[] => {
            if ( state.currentUser.centersUser == undefined || state.currentUser.centersUser.length == 0)
                return [];
            return state.currentUser.centersUser.filter((element) => {
                return element.center.active
            }).map((element) => {
                const cbCenterItem = new CbCenterItem();
                cbCenterItem.label = element.center?.code + " - " + element.value + " - " + element.center?.typology?.code3;
                cbCenterItem.icon = element.center?.species?.code3 == "PO" ? "images/pig-black.svg" : "images/rabbit.svg";
                cbCenterItem.isSelected = element.fav;
                cbCenterItem.id = element.center?.id;
                return cbCenterItem;
            });
        },
        getCentersUserFav: (state): CbCenterItem[] => {
            if ( state.currentUser.centersUser == undefined || state.currentUser.centersUser.length == 0)
                return [];
            return state.currentUser.centersUser.filter((element) => {
                return element.center.active && element.fav
            }).map((element) => {
                const cbCenterItem = new CbCenterItem();
                cbCenterItem.label = element.center?.code + " - " + element.value + " - " + element.center?.typology?.code3;
                cbCenterItem.icon = element.center?.species?.code3 == "PO" ? "images/pig-black.svg" : "images/rabbit.svg";
                cbCenterItem.isSelected = element.fav;
                cbCenterItem.id = element.center?.id;
                return cbCenterItem;
            });
        },
    },
    actions: {
        /**
         * Charge l'utilisateur courant
         */
        async loadUser() {
            const user = await authenticationHelper.getUserInfo();

            if(!user) {
                console.error("No user");
                return;
            }

            if(!user.profile) {
                console.error("No user.profile");
                return;
            }

            this.currentUser = new FrontUser(user);
            await this.loadCurrentUserCenters();
        },

        async setCurrentCenter(centerId: number) {
            const CentreStore = useCenterStore();
            await CentreStore.get(centerId);
            if (CentreStore.current && CentreStore.current.id === centerId) {
                this.currentCenter = CentreStore.current;
            }
            return this.currentCenter;
        },

        /**
         * Charge les centres de l'utilisateur courant
         * // todo refacto :
         *  - méthode privée : possible ?
         */
        async loadCurrentUserCenters() {
            this.currentUser.centersUser = [];
            const CentreStore = useCenterStore();
            const OptionStore = useOptions();

            let FavCenter = false;
            let listCenterAutorize: any[] = [];
            let OptionsParamCenterid: number = 0;
            let listCenterDoublon: string[] = [];
            let listCenterFilter: any[] = [];

            //Initialisation des centres autorisés
            //GDPORC_chefdecentre_codesite peut être un tableau ou une chaine de caractères
            //On le transforme donc en tableau si besoin
            const centerChef = Array.isArray( this.currentUser.codeSite_chefdecentre) ? this.currentUser.codeSite_chefdecentre : [this.currentUser.codeSite_chefdecentre];

            //GDPORC_codesite peut être un tableau ou une chaine de caractères
            //On le transforme donc en tableau si besoin
            const centerLabo = Array.isArray(this.currentUser.codesite) ? this.currentUser.codesite : [this.currentUser.codesite];

            //On concatène les deux tableaux
            let listCodeCenterAuthorized = centerChef.concat(centerLabo);
            console.log("Recherche les options : "+OptionStore.datas.length+" dans le store");

            OptionsParamCenterid = +OptionStore.getOptionByCodeForUser("FAV_CENTER", this.currentUser.email)?.value!;
            console.log("Option FAV_CENTER pour l'utilisateur "+this.currentUser.email+" : "+OptionsParamCenterid);

            // TODO refacto: a revoir
            await CentreStore.load({page:1,pageSize: 2147483647} as ICenterFilter);

            //eg: centerCodeAuthorized = STE|PO
            for(const centerCodeAuthorized of listCodeCenterAuthorized) {
                listCenterFilter = [];
                // Récupération des centres autorisés plus les parents(centre de quarantaine)
                if (CentreStore.datas) {
                    listCenterFilter = CentreStore.datas.filter( (c: ICenter) =>
                        c.code + "|" + c.species?.code3 == centerCodeAuthorized ||
                        c.parent?.code + "|" + c.parent?.species?.code3 ==
                        centerCodeAuthorized
                    );
                }

                for(const center of listCenterFilter) {
                    if ( listCenterDoublon.includes( center.code + "|" + center.species?.code3) ) {
                        continue;
                    } else {
                        listCenterDoublon.push(center.code + "|" + center.species?.code3);
                    }

                    if (OptionsParamCenterid != 0) {
                        if (OptionsParamCenterid == center.id) {
                            FavCenter = true;
                        } else {
                            FavCenter = false;
                        }
                    }

                    if(center.isActive) {
                        let model = new CenterAuthorize();
                        model.value = center.species?.value;
                        model.label = center.name;
                        model.center = center;
                        model.fav = FavCenter;
                        model.quarantaine = center.parent?.code != undefined && listCenterFilter.length > 1;
                        model.sortingCenter =
                            (center.parent?.code == undefined
                                ? center.code + "|" + center.species?.code3
                                : centerCodeAuthorized) +
                            "|" +
                            (center.parent?.code == undefined ? center.id : 9999) +
                            "|" +
                            center.name;
                        listCenterAutorize.push( model );
                    }
                }
            }           
                
            listCenterAutorize.sort((a, b) => a.sortingCenter > b.sortingCenter ? 1 : -1);
            this.currentUser.centersUser = listCenterAutorize;

            if (this.currentUser.centersUser.length === 0) {
                throw new Error("No authorized center found for this user");
            }

            const favList = this.getCentersUserFav;
            this.currentCenter = favList.length > 0
                ? this.currentUser.centersUser.find(e => e.center.id === favList[0].id)?.center!
                : this.currentUser.centersUser[0].center;

            // Si laissé, un rafraîchissement de n'importe quelle page renvoie systématiquement sur la page d'accueil
            // router.push({ name: "Home" }); // TODO refacto: a revoir : utilisé pour redirigé après le chargement des règles, et donc des routes. ==> mauvais placement du chargement des routes ?
        },

        /**
         * Met à jour le centre favori de l'utilisateur courant
         * @param idcenter
         */
        async setCenterFav(idcenter: number) {
            this.currentUser.centersUser.forEach((center: CenterUserList) => {
                center.fav = false;
                if (center.center.id == idcenter) {
                    center.fav = true;
                }
            });
        },
    },
});
